/**
 * 根据权限配置菜单
 * 每一个menu项参数：key, label, path, number 显示提示数字, query 查询对象, icon
 */
import Permit from "@/utils/permit.js";
import Allocate from "@/api/allocate.js";
import Damage from "@/api/damage.js";



let menus = []
menus.push({ key: 'Dashboard', label: '主工作台', path: '/normal/dashboard', icon: 'dashboard' })
//
if (Permit.canActions('scheduleView')) {
  menus.push({ key: 'schedules', label: '预约管理', path: '/normal/schedules', icon: 'schedules' })
  // menus.push({ key: 'schedules---', label: '预约管理--', path: '/normal/schedules---', icon: 'schedules' })
}
//==
if (Permit.canActions('rentView')) {
  let bargainMenu = { key: 'oms', label: '订单管理', icon: 'oms', children: [] }
  bargainMenu.children.push({ key: 'rents', label: '订单', path: '/normal/rents', icon: 'rents' })
  bargainMenu.children.push({ key: 'deliveries', label: '发货单', path: '/normal/deliveries', icon: 'rents' })
  menus.push(bargainMenu)
}
//
if (Permit.canActions('customerView')) {
  menus.push({ key: 'customers', label: '客户管理', path: '/normal/customers', icon: 'customers' })
}

//
let wmsMenu = { key: 'wms', label: '现货管理', icon: 'wms', children: [] }
if (Permit.canActions('wmsInventoryView')) {
  wmsMenu.children.push({ key: 'wmsInventories', label: '现货', path: '/normal/wms/inventories' })
}
if (Permit.canActions('wmsAllocateView')) {
  wmsMenu.children.push({ key: 'wmsAllocates', label: '调拨单', path: '/normal/wms/allocates?initFilter=applying', numberFun: Allocate.pendingDealCount, emitNames: ['allocateApplyIn', 'allocateAgree', 'allocateAgreeAndPick', 'allocateReject', 'allocateDelete'] })
}
if (Permit.canActions('wmsDamageView')) {
  wmsMenu.children.push({ key: 'wmsDamages', label: '报损单', path: '/normal/wms/damages?initFilter=newly', numberFun: Damage.pendingAgreeCount, emitNames: ['damageInventoryDamage', 'damageAgree', 'damageReject', 'damageDelete'] })
}
if (Permit.canActions('wmsInventoryView')) {
  wmsMenu.children.push({ key: 'wmsStockInsCount', label: '入库单', path: '/normal/wms/stock-ins/count' })
  wmsMenu.children.push({ key: 'wmsStockOutsCount', label: '出库单', path: '/normal/wms/stock-outs/count' })
}
menus.push(wmsMenu)
menus.push({ key: 'reports', label: '报表', path: '/normal/fn-reports', icon: 'schedules' })



// let opensFree = function () {
//   return this.items.map((item) => item.key)
// }
let opensCharge = function () {
  if (this.items.length > 1 && this.items[1].children && this.items[1].children.length != 0) {
    return [this.items[1]].map((item) => item.key)
  }
  return []
}
export default {
  items: menus.filter(menu => !menu.children || (menu.children && menu.children.length != 0)),
  opens: opensCharge,
};